import QRCode from 'react-qr-code';

interface EmployeeQrCard {
  id: number;
  first_name: string;
  last_name: string;
  qr_code_token: string;
}

interface EmployeeQrCardsPrintProps {
  employees: EmployeeQrCard[];
}

export const EmployeeQrCardsPrint = ({
  employees,
}: EmployeeQrCardsPrintProps) => {
  return (
    <div>
      {employees.map((employee) => (
        <div
          key={employee.id}
          className="keep-together"
          style={{
            display: 'inline-block',
            verticalAlign: 'top',
            width: 'calc((100% - 1.5rem) / 3)',
            margin: '0.25rem',
            border: '1px solid #ccc',
            padding: '0.75rem 0.5rem',
            textAlign: 'center',
          }}
        >
          <QRCode
            style={{ margin: '0 auto' }}
            size={110}
            value={employee.qr_code_token}
          />
          <p
            style={{
              margin: '0.5rem 0 0',
              fontWeight: 600,
              fontSize: '0.875rem',
              wordBreak: 'break-word',
            }}
          >
            {employee.first_name} {employee.last_name} (#{employee.id})
          </p>
        </div>
      ))}
    </div>
  );
};
